import { HttpBackend, HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CustomTranslateLoaderService implements TranslateLoader {
	private readonly httpBackend = inject(HttpBackend);
	private readonly http = new HttpClient(this.httpBackend);

	getTranslation(lang: string): Observable<TranslationObject> {
		const timestamp = Date.now();
		return forkJoin([
			this.http
				.get<TranslationObject>(`./assets/i18n/${lang}.json?ts=${timestamp}`)
				.pipe(catchError(() => of({}))),
			this.http
				.get<TranslationObject>(`./assets/i18n-shared/${lang}.json?ts=${timestamp}`)
				.pipe(catchError(() => of({}))),
		]).pipe(
			map(([appTranslations, libTranslations]) => {
				return { ...libTranslations, ...appTranslations };
			}),
		);
	}
}
